import script from "./SetPinPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SetPinPage.vue?vue&type=script&setup=true&lang=ts"

import "./SetPinPage.vue?vue&type=style&index=0&id=3cf2d3cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cf2d3cd"]])

export default __exports__